/* PartOtter: vehicle selector, VIN lookup and "My garage".
   The saved car lives in this browser only (localStorage key po_vehicle). */
(function () {
  var KEY = 'po_vehicle';
  function load() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function save(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  function label(v) { return v ? [v.year, v.model].filter(Boolean).join(' ') : ''; }
  function full(v) { return v ? [v.year, v.make, v.model].filter(Boolean).join(' ') : ''; }

  function paintGarage() {
    var v = load();
    document.querySelectorAll('[data-po-garage-label]').forEach(function (el) { el.textContent = v ? label(v) : 'Add vehicle'; });
    document.querySelectorAll('[data-po-side-label]').forEach(function (el) {
      var t = el.getAttribute('data-template');
      if (v && t) el.textContent = t.replace('{car}', label(v));
    });
  }

  function opt(sel, value, text) { var o = document.createElement('option'); o.value = value; o.textContent = text || value; sel.appendChild(o); }
  function reset(sel, ph) { sel.innerHTML = ''; opt(sel, '', ph); }

  function initYmm(root) {
    var yearSel = root.querySelector('[data-po-year]');
    var makeSel = root.querySelector('[data-po-make]');
    var modelSel = root.querySelector('[data-po-model]');
    var partIn = root.querySelector('[data-po-part]');
    var form = root.querySelector('[data-po-ymm-form]');
    var vinForm = root.querySelector('[data-po-vin]');
    var vinMsg = root.querySelector('[data-po-vin-msg]');
    var searchUrl = root.getAttribute('data-search') || '/search';
    var data = {};
    var now = new Date().getFullYear() + 1;
    for (var y = now; y >= 1980; y--) opt(yearSel, String(y));

    function fillModels(make, keep) {
      reset(modelSel, 'Model');
      var list = data[make] || [];
      list.forEach(function (m) { opt(modelSel, m); });
      if (keep && list.indexOf(keep) === -1) opt(modelSel, keep);
      modelSel.disabled = !make;
      if (keep) modelSel.value = keep;
    }
    function setVehicle(v) {
      if (!v) return;
      if (v.year) { if (![].some.call(yearSel.options, function (o) { return o.value === v.year; })) opt(yearSel, v.year); yearSel.value = v.year; }
      if (v.make) { if (!data[v.make] && ![].some.call(makeSel.options, function (o) { return o.value === v.make; })) opt(makeSel, v.make); makeSel.value = v.make; }
      fillModels(v.make, v.model);
    }

    fetch(root.getAttribute('data-vehicles')).then(function (r) { return r.json(); }).then(function (d) {
      data = d || {};
      Object.keys(data).sort().forEach(function (m) { opt(makeSel, m); });
      setVehicle(load());
    }).catch(function () { setVehicle(load()); });

    makeSel.addEventListener('change', function () { fillModels(makeSel.value); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = { year: yearSel.value, make: makeSel.value, model: modelSel.value };
      if (v.make || v.model) { save(v); paintGarage(); }
      var part = (partIn.value || '').trim();
      var tries = [[v.year, v.make, v.model, part], [v.make, v.model, part], [v.make, part], [v.make, v.model], [v.make], [part]]
        .map(function (a) { return a.filter(Boolean).join(' '); })
        .filter(function (q, i, arr) { return q && arr.indexOf(q) === i; });
      if (!tries.length) { makeSel.focus(); return; }
      var btn = form.querySelector('button[type=submit]'); if (btn) btn.disabled = true;
      var hz = function (s) { return String(s).toLowerCase().replace(/['’]/g, '').replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); };
      if (v.make && /wiper/i.test(part)) {
        var wipers = '/collections/' + hz(v.make) + '-wiper-blades';
        var toWipers = function () { fetch(wipers, { method: 'HEAD' }).then(function (r) { if (r.ok) window.location.href = wipers; else search(); }).catch(search); };
        if (!v.model) { toWipers(); return; }
        fetch('/products/' + hz(v.make + ' ' + v.model + ' windshield wiper blades') + '.js')
          .then(function (r) { if (r.ok) window.location.href = r.url.replace(/\.js(\?.*)?$/, '') + '#wiper-sizes'; else toWipers(); })
          .catch(toWipers);
        return;
      }
      if (v.make && !v.model && !part) {
        var mk = '/collections/' + hz(v.make) + '-parts';
        fetch(mk, { method: 'HEAD' }).then(function (r) { if (r.ok) window.location.href = mk; else search(); }).catch(search);
        return;
      }
      search();
      function search() {
      var go = function (q) { window.location.href = searchUrl + '?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(q); };
      (function next(i) {
        if (i >= tries.length) return go(tries[0]);
        fetch(searchUrl + '/suggest.json?resources[type]=product&resources[limit]=1&q=' + encodeURIComponent(tries[i]))
          .then(function (r) { return r.json(); })
          .then(function (j) { var n = j && j.resources && j.resources.results && j.resources.results.products; if (n && n.length) go(tries[i]); else next(i + 1); })
          .catch(function () { go(tries[i]); });
      })(0);
      }
    });

    if (vinForm) vinForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var vin = (vinForm.vin.value || '').trim().toUpperCase();
      vinMsg.hidden = false;
      if (!/^[A-HJ-NPR-Z0-9]{17}$/.test(vin)) { vinMsg.textContent = 'A VIN is 17 letters and numbers (no I, O or Q).'; return; }
      vinMsg.textContent = 'Looking up your VIN…';
      fetch('https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVinValues/' + vin + '?format=json')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var r = d && d.Results && d.Results[0];
          if (!r || !r.Make) throw new Error('none');
          var make = r.Make.toLowerCase().replace(/\b\w/g, function (c) { return c.toUpperCase(); });
          var known = Object.keys(data).filter(function (k) { return k.toLowerCase() === r.Make.toLowerCase(); })[0];
          var v = { year: r.ModelYear, make: known || make, model: r.Model };
          save(v); setVehicle(v); paintGarage();
          var extra = [r.Trim, r.DisplacementL ? (parseFloat(r.DisplacementL).toFixed(1) + 'L') : ''].filter(Boolean).join(' ');
          vinMsg.textContent = 'Found: ' + full(v) + (extra ? ' ' + extra : '') + '. Saved to My garage.';
        })
        .catch(function () { vinMsg.textContent = 'We could not decode that VIN. Pick year, make and model above instead.'; });
    });
  }

  /* Fitment hints from titles like "Head Gasket 2014-2019 Jeep,Ram 3.0L" */
  function tagCards() {
    var v = load(); if (!v || !v.year || !v.make) return;
    var yr = parseInt(v.year, 10), mk = v.make.toLowerCase().replace(/[^a-z]/g, '');
    document.querySelectorAll('.card-wrapper').forEach(function (card) {
      if (card.hasAttribute('data-po-fit')) return;
      var hs = [].slice.call(card.querySelectorAll('.card__heading')); var h = hs.filter(function (x) { return x.offsetParent !== null; })[0] || hs[hs.length - 1]; if (!h) return;
      var t = h.textContent;
      if (/\b1\s?:\s?(12|18|24|32|43|50|64|87)\b|die-?cast|scale model/i.test(t)) { card.setAttribute('data-po-fit', 'no'); return; }
      var m = t.match(/\b(19[5-9]\d|20[0-4]\d)(?:\s*[-–]\s*(19[5-9]\d|20[0-4]\d))?\b/);
      if (!m) return;
      var a = parseInt(m[1], 10), b = m[2] ? parseInt(m[2], 10) : a;
      var flat = t.toLowerCase().replace(/[^a-z]/g, ' ');
      var makeHit = (' ' + flat + ' ').indexOf(' ' + mk + ' ') > -1 || flat.replace(/ /g, '').indexOf(mk) > -1;
      var fits = yr >= a && yr <= b && makeHit;
      card.setAttribute('data-po-fit', fits ? 'yes' : 'no');
      if (fits) {
        var tag = document.createElement('span'); tag.className = 'po-fit'; tag.textContent = 'Listed for your ' + yr + ' ' + v.make;
        h.parentNode.insertBefore(tag, h);
      }
    });
  }

  function init() {
    paintGarage();
    tagCards();
    if (window.MutationObserver && !window.__poObs) {
      window.__poObs = new MutationObserver(function () { tagCards(); });
      window.__poObs.observe(document.body, { childList: true, subtree: true });
    }
    document.querySelectorAll('[data-po-ymm]').forEach(initYmm);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
